import { Avatar, Box, Card, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { motion } from 'framer-motion'
import { MarketplaceIntegrationItemFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  integration: MarketplaceIntegrationItemFragment
  installed: boolean
}

export const IntegrationItemCard = ({ integration, installed }: Props) => {
  const { navigation } = useNavigation()
  const [open, toggleHover] = useToggle(false)

  type ColorValues = 'champagne' | 'malibu' | 'purple'

  const statusMap: Record<string, { label: string; color: ColorValues }> = {
    'coming soon': { label: i18n.t('marketplace.modules.soon'), color: 'champagne' },
    new: { label: i18n.t('marketplace.modules.new'), color: 'malibu' },
    updated: { label: i18n.t('marketplace.modules.new'), color: 'malibu' },
  }

  const getStatusValue = (badgeLabel: string | undefined) => {
    return badgeLabel && statusMap[badgeLabel] ? { ...statusMap[badgeLabel] } : undefined
  }

  const status = getStatusValue(integration.statusBadge!)
  const toolTipLabel = integration
    .countries!.slice(3)
    .map((country) => <Box key={country.title}>{country.title}</Box>)

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  }

  return (
    <motion.div key={integration.datoId} variants={item}>
      <Card
        to={navigation.discover.marketplace.item.fullPath({
          id: integration.datoId,
        })}
      >
        <Card.Eyebrow>
          <Avatar
            url={integration.logo!.url!}
            label=""
            backgroundColor={integration.logoBackground?.hex}
            framed
          />
          {installed ? (
            <Tag type="lime" solid>
              {i18n.t('marketplace.modules.installed')}
            </Tag>
          ) : (
            status && (
              <Tag type={status?.color} solid>
                {status?.label}
              </Tag>
            )
          )}
        </Card.Eyebrow>

        <Card.Title>{integration.name!}</Card.Title>
        <Card.Description>{integration.shortDescription!}</Card.Description>
        <Card.Footer>
          <Box flexDirection="row" gap="s12">
            {integration.countries!.slice(0, 3).map((country) => (
              <Tag key={country.title}>{country.title}</Tag>
            ))}
            <Tooltip.Alt
              attachment="top center"
              label={toolTipLabel}
              open={open && integration.countries!.length > 3}
              toggle={toggleHover}
            >
              <Box>
                {integration.countries!.length > 3 && (
                  <Tag>+{integration.countries!.length - 3} </Tag>
                )}
              </Box>
            </Tooltip.Alt>
          </Box>
        </Card.Footer>
      </Card>
    </motion.div>
  )
}
